import { Link, NavLink } from 'react-router-dom'
import './Sidebar.scss'
import { useState } from 'react'
import LogoS from '../../assets/images/logo-s.png'
import LogoSubtitle from '../../assets/images/logo_sub.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faHome,
  faEnvelope,
  faUser,
  faClose,
  faBars,
  faSuitcase,
} from '@fortawesome/free-solid-svg-icons'
import {
  faLinkedin,
  faGithub,
  faSkype,
} from '@fortawesome/free-brands-svg-icons'

type Props = {}

const Sidebar = (props: Props) => {
  const [showNav, setShowNav] = useState(false)
  return (
    <div className="nav-bar">
      <Link
        className="logo"
        to="/"
        onClick={() => {
          setShowNav(!showNav)
        }}
      >
        <img src={LogoS} alt="logo" />
        <img className="sub-logo" src={LogoSubtitle} alt="sub-logo" />
      </Link>
      <nav className={showNav ? 'mobile-show' : ''}>
        <NavLink
          className={({ isActive }) => (isActive ? 'active' : '')}
          to="/"
          onClick={() => {
            setShowNav(!showNav)
          }}
        >
          <FontAwesomeIcon icon={faHome} color="#4d4d4e" />
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            isActive ? 'active about-link' : 'about-link'
          }
          to="/about"
          onClick={() => {
            setShowNav(!showNav)
          }}
        >
          <FontAwesomeIcon icon={faUser} color="#4d4d4e" />
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            isActive ? 'active portfolio-link' : 'portfolio-link'
          }
          to="/portfolio"
          onClick={() => {
            setShowNav(!showNav)
          }}
        >
          <FontAwesomeIcon icon={faSuitcase} color="#4d4d4e" />
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            isActive ? 'active contact-link' : 'contact-link'
          }
          to="/contact"
          onClick={() => {
            setShowNav(!showNav)
          }}
        >
          <FontAwesomeIcon icon={faEnvelope} color="#4d4d4e" />
        </NavLink>
        <FontAwesomeIcon
          onClick={() => {
            setShowNav(!showNav)
          }}
          icon={faClose}
          color="#ffd700"
          size="3x"
          className="close-icon"
        />
      </nav>
      <ul>
        <li>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.linkedin.com/in/volodymyr-sokolenko-46059984?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BhjZWrI%2FMSaiPUnA6KNW9VQ%3D%3D"
          >
            <FontAwesomeIcon icon={faLinkedin} color="#4d4d4e" />
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://github.com/vvs0503624459"
          >
            <FontAwesomeIcon icon={faGithub} color="#4d4d4e" />
          </a>
        </li>
        <li>
          <a target="_blank" rel="noreferrer" href="skype:pj.Shean">
            <FontAwesomeIcon icon={faSkype} color="#4d4d4e" />
          </a>
        </li>
      </ul>
      <FontAwesomeIcon
        onClick={() => {
          setShowNav(!showNav)
        }}
        icon={faBars}
        color="#ffd700"
        size="3x"
        className="hamburger-icon"
      />
    </div>
  )
}

export default Sidebar
